import {Route, Routes, Outlet, Navigate, useNavigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {EmployersListWrapper} from './employers-list/EmployersList'
import {AddEmployers} from './employers-form'
import {EditEmployersWrapper} from './employers-form/EditEmployersWrapper'
import EmployersHeader from './employers-form/EmployersHeader'
import EmployersView from './employers-form/EmployersView'

const employersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Employers Management',
    path: '/employers',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const EmployersPage = () => {
  const navigate = useNavigate();
  function goBack() {
    navigate(-1);
  }
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <PageTitle breadcrumbs={employersBreadcrumbs}>Employers list</PageTitle>
              <EmployersListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='list' />} />
      {/* <Route
        path='/add'
        element={
          <>
            {' '}
            <PageTitle breadcrumbs={employersBreadcrumbs}>Employers Add</PageTitle>
            <AddEmployers />
          </>
        }
      /> */}
      <Route
        path='/edit/:id'
        element={
          <>
            <PageTitle breadcrumbs={employersBreadcrumbs}>Employers Edit</PageTitle>
            <EditEmployersWrapper />
          </>
        }
      />
    <Route
        path='/view/:id'
        element={
          <>
            <PageTitle breadcrumbs={employersBreadcrumbs}>View Employer</PageTitle>
            <button
              onClick={goBack}
              style={{ marginBottom: "15px" }}
              className="btn btn-sm btn-info px-6 align-self-center text-nowrap"
            >
              <i className="bi bi-reply fs-4 me-2"></i> Go Back
            </button>
            {/* <EditEmployersWrapper /> */}
            <EmployersHeader />
            <EmployersView />
          </>

        }
      />
      </Routes> 
  )
}

export default EmployersPage
